import React, { useEffect, useState } from "react";
import { ReportAPI } from "../../api/apiClient";

interface Props {
  projectId: number;
  //selectedDate: string;
}

type ConsumptionRow = {
  componentNo: number;
  component?: string;
  unitName?: string;
  date: string;
  used: number;
};

export default function MaterialConsumptionReport({
  projectId,
  //selectedDate,
}: Props) {
  const [rows, setRows] = useState<ConsumptionRow[]>([]);
  const [loading, setLoading] = useState(false);

  // ✅ Auto-load when date changes {|| !selectedDate} ->old code
  //Auto-load when projectId changes

  useEffect(() => {
    if (!projectId ) return;

    const loadReport = async () => {
      try {
        setLoading(true);

        const data: ConsumptionRow[] =
          await ReportAPI.getMaterialConsumption({
            project: projectId,
            //asOnDate: selectedDate,
          });

        setRows(data);
      } catch (error) {
        console.error("Material Consumption Error:", error);
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [projectId]); //selectedDate

  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">

      {/* HEADER */}
      {/*<div className="bg-blue-800 text-white px-4 py-3 font-semibold">*/}
      <div className="bg-[#1788ac] text-white px-4 py-3 font-semibold">

        MATERIALS CONSUMPTION
      </div>

      {/* SUB HEADER */}
     {/* <div className="bg-gray-200 px-4 py-2 text-sm font-semibold">
        REPORTED TODAY
      </div>*/}

      <div className="p-4">

        {loading && (
          <div className="text-gray-500 text-sm">
            Loading material consumption…
          </div>
        )}
        {/*No material consumption reported for this date */}
        {!loading && rows.length === 0 && (
          <div className="text-gray-500 text-center py-6">
            No material consumption available

          </div>
        )}

        {!loading && rows.length > 0 && (
          <div className="space-y-6">
            {rows.map((item) => (
              <div
                key={item.componentNo}
                className="text-center border-b pb-4 last:border-none"
              >
                <div className="text-gray-700 font-medium">
                  {item.component}
                </div>

                <div className="text-2xl font-bold text-gray-900">
                  {item.used.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  <span className="text-base font-medium">
                    {item.unitName?.trim()}
                  </span>
                </div>

                <div className="text-xs text-gray-500">
                  {new Date(item.date).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>
        )}

      </div>

      {/* Bottom Accent */}
    {/*  <div className="h-1 bg-green-700" />*/}
    </div>
  );
}
